import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Vacature</title>
                <link rel="canonical" href={route("work-at")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta
                    property="og:description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta property="og:url" content={route("work-at")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Vacature - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-7xl">
                        is opzoek naar jou!
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="requirements"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero>

                <div
                    className="relative xs:p-8 sm:p-8 md:p-16 lg:p-32"
                    id="requirements"
                >
                    <div className="max-w-5xl mx-auto mt-12">
                        <p className="mt-5 text-xl text-gray-100">
                            Ben je klaar voor een uitdagende functie waarin je
                            niet alleen je passie voor fitness kunt uitleven,
                            maar ook je sociale vaardigheden kunt inzetten? Dan
                            hebben we bij WE ARE de perfecte baan voor jou!
                            Bekijk hieronder onze openstaande vacatures en
                            reageert snel want wie weet behoor jij binnenkort
                            tot het WE ARE team!
                        </p>

                        <div className="flex flex-col items-center mt-12 space-y-4">
                            <a
                                href={route("vacancy1")}
                                className="uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                Fulltime Trainer
                            </a>
                            <a
                                href={route("vacancy2")}
                                className="uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                Parttime Trainer
                            </a>
                            <a
                                href={route("vacancy3")}
                                className="uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                            >
                                (Nazorg) Trainer
                            </a>
                        </div>
                    </div>

                    {/* <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            De essentie van de functie
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Bij WE ARE geloven we dat een gezonde levensstijl
                            meer is dan alleen trainen en gezond eten. Het gaat
                            ook om je thuis voelen en deel uitmaken van een
                            community. Als fitnessinstructeur en gastheer speel
                            jij hierin een cruciale rol. Je begeleidt en coacht
                            deelnemers om hun doelen te bereiken, maar zorgt er
                            ook voor dat ze zich welkom en gewaardeerd voelen.
                            Het is jouw taak om een warme en motiverende sfeer
                            te creëren waarin mensen zich op hun gemak voelen en
                            graag terugkomen.
                        </p>
                        <h2 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Jouw rol als trainer
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Als trainer bij WE ARE ben je verantwoordelijk voor
                            het trainen en coachen van onze deelnemers. Of ze nu
                            hun conditie willen verbeteren, spiermassa willen
                            opbouwen of gewicht willen verliezen, jij staat voor
                            ze klaar met deskundig advies en persoonlijke
                            begeleiding. Hier zijn enkele kerntaken die je als
                            fitnessinstructeur zult uitvoeren:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Begeleiden van individuele en groepstrainingen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Opstellen en aanpassen van trainingsschema's
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Adviseren over voeding en leefstijl
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Demonstreren van oefeningen en technieken
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Bewaken van de veiligheid tijdens trainingen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Motiveren en inspireren van deelnemers
                            </li>
                        </ul>
                        <p className="mt-5 text-xl text-gray-100">
                            Je houdt de vinger aan de pols als het gaat om de
                            nieuwste trends en ontwikkelingen op het gebied van
                            beweging, voeding en mindset. Zo kun je onze
                            deelnemers altijd van de beste en meest actuele
                            adviezen voorzien.
                        </p>
                        <h2 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Jouw rol als gastheer
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Naast je taken als fitnessinstructeur, vervul je ook
                            de belangrijke rol van gastheer. In deze
                            hoedanigheid zorg je ervoor dat onze deelnemers zich
                            welkom en gewaardeerd voelen vanaf het moment dat ze
                            binnenstappen tot het moment dat ze weer vertrekken.
                            Enkele van je taken als gastheer zijn:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Verwelkomen van deelnemers en zorgen voor een
                                prettige sfeer
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Aanspreekpunt zijn voor vragen en opmerkingen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Zorgen dat de faciliteiten er altijd verzorgd
                                uitzien
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Kleine maar essentiële huishoudelijke taken
                                uitvoeren
                            </li>
                        </ul>
                        <p className="mt-5 text-xl text-gray-100">
                            Door deze combinatie van rollen creëer je een
                            omgeving waarin deelnemers zich niet alleen fysiek
                            uitgedaagd voelen, maar ook emotioneel verbonden
                            raken met WE ARE.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wat maakt deze functie zo bijzonder?
                        </h2>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Veelzijdigheid
                        </h3>
                        <p className="mt-5 text-xl text-gray-100">
                            In deze functie verveel je je nooit! De combinatie
                            van fitnessinstructeur en gastheer zorgt voor een
                            gevarieerde werkdag waarin je zowel je fysieke als
                            sociale vaardigheden kunt inzetten. Het ene moment
                            geef je een intensieve training, het volgende moment
                            voer je een motiverend gesprek met een deelnemer die
                            het even moeilijk heeft.
                        </p>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Persoonlijke ontwikkeling
                        </h3>
                        <p className="mt-5 text-xl text-gray-100">
                            Bij WE ARE krijg je volop kansen om jezelf te
                            ontwikkelen. We moedigen je aan om nieuwe ideeën aan
                            te dragen en mee te denken over de groei van ons
                            bedrijf. Je leert niet alleen over de nieuwste
                            fitnesstrends, maar ontwikkelt ook je communicatieve
                            en leiderschapsvaardigheden.
                        </p>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Betekenisvol werk
                        </h3>
                        <p className="mt-5 text-xl text-gray-100">
                            Als fitnessinstructeur en gastheer bij WE ARE heb je
                            echt impact op het leven van mensen. Je helpt hen
                            niet alleen hun fysieke doelen te bereiken, maar
                            draagt ook bij aan hun mentale welzijn en
                            zelfvertrouwen. De dankbaarheid en vooruitgang van
                            je deelnemers maken deze baan ontzettend waardevol.
                        </p>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Teamwork
                        </h3>
                        <p className="mt-5 text-xl text-gray-100">
                            Hoewel je veel zelfstandig werkt, maak je ook deel
                            uit van een hecht team van professionals. Samen
                            zorgen jullie ervoor dat WE ARE een plek is waar
                            mensen graag komen en blijven komen.
                        </p>
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Wat verwachten we van jou?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Om succesvol te zijn in deze functie, zoeken we
                            iemand met de volgende eigenschappen en
                            kwalificaties:
                        </p>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            Persoonlijke eigenschappen
                        </h3>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Zelfstandigheid: Je kunt goed op eigen
                                initiatief werken en problemen oplossen.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Energie: Je hebt een positieve uitstraling en
                                weet anderen te motiveren.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Integriteit: Je bent betrouwbaar en handelt
                                altijd in het belang van de deelnemers.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Klantgerichtheid: Je stelt de behoeften van de
                                deelnemers centraal.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Initiatief: Je ziet kansen en komt proactief met
                                ideeën.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Besluitvaardigheid: Je durft beslissingen te
                                nemen en staat achter je keuzes.
                            </li>
                        </ul>
                        <h3 className="xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white mt-12">
                            (Opleidings)eisen en werkervaring
                        </h3>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Minimaal 1 jaar ervaring in Personal training,
                                groepsfitness en fitness.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                De fysieke mogelijkheid om oefeningen en
                                bewegingen te demonstreren.
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Je beoefend de sport zelf en bent het voorbeeld
                                voor onze deelnemers.
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Waarom solliciteren?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Werken bij WE ARE betekent meer dan alleen een baan.
                            Het is een kans om deel uit te maken van een
                            groeiend bedrijf dat mensen helpt het beste uit
                            zichzelf te halen. Je krijgt de mogelijkheid om je
                            passie voor fitness te combineren met je sociale
                            vaardigheden, in een omgeving die persoonlijke groei
                            en ontwikkeling stimuleert.
                        </p>
                        <p className="mt-5 text-xl text-gray-100">
                            Bovendien bieden we:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Baan voor 20 - 30 uur met uitzicht op fulltime
                                dienstverband
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een competitief salaris (netto 2227 - 2364 euro
                                excl. vakantiegeld o.b.v 36 uur)
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Flexibele werktijden (afhankelijk van het
                                rooster)
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Doorgroeimogelijkheden binnen het bedrijf
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een leuk en gemotiveerd team van collega's
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Mogelijkheid om zelf te trainen in de WE ARE
                                sportscholen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Veel en leuke bedrijfsuitjes / teambuilding om
                                het team nog hechter te maken
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een telefoon van de zaak
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een goede pensioenregeling
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Reiskostenvergoeding (in overleg)
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Klaar voor de uitdaging?
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Ben jij die energieke, klantgerichte fitnessfanaat
                            die we zoeken? Iemand die net zo enthousiast wordt
                            van het geven van een killer workout als van het
                            creëren van een warme, welkome sfeer? Dan nodigen we
                            je van harte uit om te solliciteren!
                        </p>
                        <p className="mt-5 text-xl text-gray-100">
                            Stuur je cv en een motivatiebrief naar{" "}
                            <a
                                href="mailto:info@we-are.club"
                                className="text-we-are-yellow font-medium"
                            >
                                info@we-are.club
                            </a>{" "}
                            en vertel ons waarom jij de perfecte kandidaat bent
                            voor deze functie. We kijken ernaar uit om je te
                            leren kennen en wie weet word jij binnenkort
                            onderdeel van ons WE ARE team!
                        </p>
                    </div> */}
                </div>

                <Contact />
            </div>
        </Default>
    );
}
